import React, { FC } from 'react'

import { Tag } from 'src/components/atoms'

type Props = { className?: string }

export const RequiredLabel: FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <Tag size="s" type="error" state="outline">
        必須
      </Tag>
    </div>
  )
}
